

const fakeBackendResponse = {
  data: [
    {
      HUMI: {
        name: 'Humidity',
        color: '#757DC6'
      },

      LINEBRK: {
        name: 'Linebreak',
        color: '#555FB9'
      },

      MOTION: {
        name: 'Motion',
        color: '#C3EFDF'
      },

      ORIENT: {
        name: 'Orientation',
        color: '#50589E'
      },

      TEMP: {
        name: 'Temperature',
        color: '#DE3C63'
      },

      CO2: {
        name: 'Carbon dioxide',
        color: '#EEA620'
      },

      LIGHT: {
        name: 'Light exposure',
        color: '#37CB95'
      }
    }
  ]
}

export default class SensorTypesApi {
  static async getList() {
    return fakeBackendResponse;
    // return Request.client.get("/sensor_types");
  }
}
